module.exports = __webpack_public_path__ + "static/images/5_smoggy_day.4e34bd1b.jpg";